import { Suspense, useState, useEffect, Fragment } from "react";
import logo from "../../assets/brand/logo.png";
import logoIcon from "../../assets/brand/logoIcon.png";
import Footer from "../footer/footer";
import Chat from "../../component/chat/chat";
import Header from "../Header/Header";
import SearchInput from "./search-input";
import { KeyboardArrowUp } from "@mui/icons-material";
import { Drawer, DrawerHeader } from "./Sidebar-drawer";
import { ROUTES } from "./sidebar-data";
import { NavLink, Outlet } from "react-router-dom";
import { Message } from "@mui/icons-material";
import "./Sidebar.scss";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
  Fab,
} from "@mui/material";
import { PreLoader } from "../../component/pre-loader/pre-loader";
import { useAppDispatch, useAppSelector } from "store/store";
import { getProfileData } from "store/features/getProfileDataSlice";
import { decryptRole } from "App";
import { v4 as uuidv4 } from "uuid";
import "../../scss/common.scss";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback, myErrorHandler } from "layout/error-boundary";

export default function Sidebar() {
  const dispatch = useAppDispatch();

  const [open, setOpen] = useState(true);
  const [subnav, setSubnav] = useState("");
  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [openChatBox, setOpenChatBox] = useState<boolean>(false);
  const userProfileData = useAppSelector((state) => state.profile.user);
  const [profile, setProfile] = useState(userProfileData);

  useEffect(() => {
    dispatch(getProfileData());
  }, [dispatch]);
  useEffect(() => {
    setProfile(userProfileData);
  }, [userProfileData]);

  let userData = JSON.parse(
    localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "null"
  );

  const myPath = window.location.pathname;
  const isResponsive = useMediaQuery("(max-width:1023px)");
  const isMobileResponsive = useMediaQuery("(max-width:576px)");
  const placeholderImage = `https://ui-avatars.com/api/?&name=${profile.firstName} ${profile.lastName}`;

  const handleSubMenu = (title: any) => {
    setSubnav(title);
  };

  const onImageError = (e: any) => {
    e.target.src = placeholderImage;
  };
  
  return (
    <div className="sidebar">
      <Box sx={{ display: "flex", minHeight: { xs: "79vh", md: "100vh" } }}>
        {/* Drawer */}
        <Drawer
          className={`mainDrawer ${!isResponsive ? "drawer" : "hideDrawer"}`}
          variant="permanent"
          open={!isResponsive ? open : !open}
          onClick={() => {
            setOpenNotificationModal(false);
          }}
        >
          {/* Drawer Header */}
          <DrawerHeader>
            <div className={`${open ? "logoHold" : "iconHold"}`}>
              {open ? (
                <img src={logo} alt="logo" className="logo" />
              ) : (
                <img src={logoIcon} alt="logo" className="logo-icon" />
              )}
            </div>
          </DrawerHeader>
          <Stack
            className="profile-image"
            justifyContent="center"
            direction="row"
            sx={{ mt: "30px", mb: !open ? 0 : "35px" }}
          >
            <div className="profile">
              <img
                src={profile?.imageId ? profile?.imageId : placeholderImage}
                alt="Profile"
                onError={onImageError}
                className={`${open || isResponsive ? "openImg" : "closeImg"}`}
              />
              <p
                style={{ textTransform: "capitalize" }}
                className={`text-white ${
                  !open && !isResponsive ? "prof-text" : "profile-text"
                }`}
              >
                {`${profile.firstName} ${profile.lastName}`}
              </p>
            </div>
          </Stack>
          {isMobileResponsive && <SearchInput />}
          {/* Sidebar menus */}
          <List
            sx={{ mt: open ? "30px" : "40px" }}
            className={open || isResponsive ? "padding-list" : ""}
          >
            {ROUTES.map((item, index) => (
              <div key={uuidv4()}>
                {item?.toShowForRole?.includes(decryptRole(userData?.role)) && (
                  <NavLink
                    to={item.path}
                    onClick={() => handleSubMenu(item.title)}
                    className="link text-white"
                    key={index}
                  >
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <ListItemButton
                        onClick={() => {
                          !item.submenu && isResponsive && setOpen(!open);
                        }}
                        disableRipple
                      >
                        <ListItemIcon
                          className="icon"
                          sx={{ minWidth: open ? "40px" : "0px" }}
                        >
                          <span className="text-white fs-14 fw-500 line-height-20">
                            {item.icon}
                          </span>
                        </ListItemIcon>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          sx={{ width: "100%" }}
                        >
                          {(open || isResponsive) && (
                            <ListItemText
                              primary={item.title}
                              className="fs-14 fw-500 line-height-20"
                              sx={{ ml: { xs: "10px", lg: 0 } }}
                            />
                          )}
                          {item.submenu && (
                            <span className="add-icon">
                              {subnav === item.title
                                ? item.closedMenu
                                : item.openendMenu}
                            </span>
                          )}
                        </Stack>
                      </ListItemButton>
                      {/* sidebar dropdown menus */}
                      <ul
                        className="subnav"
                        style={{
                          backgroundColor: "#434242",
                          paddingTop: item.submenu ? "4px" : "",
                        }}
                      >
                        {subnav === item.title &&
                          item.submenu?.map((items: any, index: number) => {
                            return (
                              <Fragment key={uuidv4()}>
                                {items?.toShowForRole?.includes(
                                  decryptRole(userData?.role)
                                ) && (
                                  <NavLink
                                    to={items.path}
                                    className={`link ${
                                      item.path === myPath
                                        ? "activeChild"
                                        : "inactiveChild"
                                    }`}
                                    key={index}
                                  >
                                    <li>
                                      <Stack
                                        direction="row"
                                        spacing={open || isResponsive ? 2 : 0}
                                        alignItems="center"
                                        sx={{ py: "8px", ml: "20px" }}
                                        onClick={() => {
                                          isResponsive && setOpen(!open);
                                        }}
                                      >
                                        {open || isResponsive ? (
                                          <p className="text-white fs-14 fw-500 line-height-20 subnav-title">
                                            {items.title}
                                          </p>
                                        ) : (
                                          <Typography
                                            className="text-white"
                                            sx={{ ml: "20px" }}
                                          >
                                            {items.hideIcon}
                                          </Typography>
                                        )}
                                      </Stack>
                                    </li>
                                  </NavLink>
                                )}
                              </Fragment>
                            );
                          })}
                      </ul>
                    </ListItem>
                  </NavLink>
                )}
              </div>
            ))}
          </List>
        </Drawer>
        {/* main */}
        <Box
          component="main"
          sx={{ p: 3, width: "100%", position: "relative" }}
        >
          <Header
            open={open}
            setOpen={setOpen}
            openNotificationModal={openNotificationModal}
            setOpenNotificationModal={setOpenNotificationModal}
          />
          <Box
            sx={{
              p: isMobileResponsive ? "10px" : "30px",
              pt: isMobileResponsive ? "20px" : "30px",
              pb: isMobileResponsive ? "20px" : "70px",
            }}
            onClick={() => {
              setOpenNotificationModal(false);
            }}
          >
            <ErrorBoundary
              FallbackComponent={ErrorFallback}
              onReset={() => {
                // reset the state of your app so the error doesn't happen again
              }}
              onError={myErrorHandler}
            >
              <Suspense fallback={<PreLoader />}>
                <Outlet />
              </Suspense>
            </ErrorBoundary>
            <Fab
              onClick={() => setOpenChatBox(!openChatBox)}
              disableRipple
              className="messageIcon"
              sx={{
                "&:hover": { backgroundColor: "#434242" },
                color: "#fff",
                backgroundColor: " #434242",
                position: "absolute",
                bottom: 10,
                right: 20,
              }}
            >
              <span className={`${openChatBox ? "rotate" : "remove-rotate"}`}>
                {openChatBox ? <KeyboardArrowUp /> : <Message />}
              </span>
            </Fab>
            {openChatBox && <Chat setOpenChatBox={setOpenChatBox} />}
          </Box>
        </Box>
      </Box>
      <Footer />
    </div>
  );
}
